export const EVENT_EQUIPMENT_REQUEST_GROUP_KEY_PREFIX = "eventEquipmentRequest";
export const EQUIPMENT_DELIVERY_FEE_GROUP_KEY_PREFIX = "equipmentDeliveryFee";
